import { getCurrentInstance } from 'vue'

export default function useEventBus() {
    const currentInstance = getCurrentInstance();
    const emitter = currentInstance.appContext.config.globalProperties.$emitter;
    return emitter;
}
